/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskBlocksSubmitFeedback } from "../funcs/riskBlocksSubmitFeedback.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskBlock } from "../models/components/riskblock.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SubmitRiskBlockFeedbackRequest,
  SubmitRiskBlockFeedbackSecurity,
} from "../models/operations/submitriskblockfeedback.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskSubmitBlockFeedbackMutationVariables = {
  request: SubmitRiskBlockFeedbackRequest;
  security?: SubmitRiskBlockFeedbackSecurity | undefined;
  options?: RequestOptions;
};

export type RiskSubmitBlockFeedbackMutationData = RiskBlock;

export type RiskSubmitBlockFeedbackMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * submitRiskBlockFeedback risk
 *
 * @remarks
 * Record thumbs-up/thumbs-down feedback for a tool call block from the block page.
 */
export function useRiskSubmitBlockFeedbackMutation(
  options?: MutationHookOptions<
    RiskSubmitBlockFeedbackMutationData,
    RiskSubmitBlockFeedbackMutationError,
    RiskSubmitBlockFeedbackMutationVariables
  >,
): UseMutationResult<
  RiskSubmitBlockFeedbackMutationData,
  RiskSubmitBlockFeedbackMutationError,
  RiskSubmitBlockFeedbackMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskSubmitBlockFeedbackMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskSubmitBlockFeedback(): MutationKey {
  return ["@gram/client", "blocks", "submitFeedback"];
}

export function buildRiskSubmitBlockFeedbackMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskSubmitBlockFeedbackMutationVariables,
  ) => Promise<RiskSubmitBlockFeedbackMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskSubmitBlockFeedback(),
    mutationFn: function riskSubmitBlockFeedbackMutationFn({
      request,
      security,
      options,
    }): Promise<RiskSubmitBlockFeedbackMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskBlocksSubmitFeedback(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
